{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              19.530164339471867,
              39.671299424952224
            ],
            [
              20.32832986000986,
              37.652027000711115
            ],
            [
              24.041302153971174,
              34.584335839754786
            ],
            [
              27.153892950932516,
              34.84965155014592
            ],
            [
              28.73070302983922,
              36.400679711496736
            ],
            [
              26.245399794270412,
              36.85410265578243
            ],
            [
              26.180244847028064,
              38.91623996071502
            ],
            [
              25.583552641825662,
              39.85515639501557
            ],
            [
              26.135782181371894,
              40.81048424021651
            ],
            [
              25.976780886929276,
              41.31288026000652
            ],
            [
              22.993707566834047,
              41.17563781520349
            ],
            [
              21.47002035510269,
              40.60654314672769
            ],
            [
              19.530164339471867,
              39.671299424952224
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}